import { render, staticRenderFns } from "./dash2.vue?vue&type=template&id=5e35e8b8&"
import script from "./dash2.vue?vue&type=script&lang=js&"
export * from "./dash2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports